export class OrphyEditor extends kendo.ui.Editor {
    placeholderText: string;

    constructor(element: Element, options?: kendo.ui.EditorOptions) {
        super(element, options);

        this.placeholderText = element.getAttribute("placeholder");
        if (this.placeholderText) {
            $(element).on("focus", this.onFocus);
            $(element).on("blur", this.onBlur);
            this.onBlur();
        }
    }

    value(): string;
    value(value: string): void;
    value(value?: string): any { 
        if ($(this.element).hasClass("inheritedSetting")) {
            // Return empty string because placeholder value is being displayed
            super.value(value);
            return "";
        }
        return super.value(value);
    }

    changeValue = (value: string): void => {
        if ($(this.element).hasClass("inheritedSetting")) {
            $(this.element).removeClass("inheritedSetting");
        }
        this.value(value);
        this.trigger("change");
    }

    onFocus = () => {
        if ($(this.element).hasClass("inheritedSetting")) {
            $(this.element).removeClass("inheritedSetting");
            this.value("");
        }
    }

    onBlur = () => {
        let value: string = this.value();
        value = value.replace(/<\/?[^>]+(>|$)/g, ""); // Strip html tags
        if (!value) {
            $(this.element).addClass("inheritedSetting");
            this.value(this.placeholderText);
        }
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
OrphyEditor.fn = OrphyEditor.prototype;
// Deep clone the widget default options
OrphyEditor.fn.options = $.extend(true, {}, kendo.ui.Editor.fn.options);
// use same live messages object as base editor
OrphyEditor.fn.options.messages =  kendo.ui.Editor.fn.options.messages;
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
OrphyEditor.fn.options.name = "OrphyEditor";
// Create a jQuery plugin.
kendo.ui.plugin(OrphyEditor);

interface JQuery {
    orphyEditor(options?: kendo.ui.EditorOptions): JQuery;
}
